export default ($) => {
  function enforceWordLimit($el, maxWords) {
    const text = $el.val().replace(/\s+/g, ' ').trim();
    const words = text.split(' ');

    if (words.length > maxWords) {
      $el.val(words.slice(0, maxWords).join(' '));
    }
  }

  const limitField = (selector, limit) => {
    const $input = $(selector);

    $input.on('input', function () {
      enforceWordLimit($input, limit);
    });

    $input.on('paste', function (e) {
      e.preventDefault();

      const pastedText = (e.originalEvent || e).clipboardData.getData('text');
      const existingText = $input.val().replace(/\s+/g, ' ').trim();
      const totalText = (existingText + ' ' + pastedText).replace(/\s+/g, ' ').trim();

      const totalWords = totalText.split(' ').slice(0, limit).join(' ');
      $input.val(totalWords);
    });
  };

  limitField('body.tribe_community_edit .tribe-community-events.form #post_title', 15);
  limitField('body.tribe_community_edit .tribe-community-events.form #post_content', 250);
};